const BOUNCE_EASING_FUN = x => {
    const n1 = 7.5625;
    const d1 = 2.75;

    if (x < 1 / d1) {
        return n1 * x * x;
    } else if (x < 2 / d1) {
        return n1 * (x -= 1.5 / d1) * x + 0.75;
    } else if (x < 2.5 / d1) {
        return n1 * (x -= 2.25 / d1) * x + 0.9375;
    } else {
        return n1 * (x -= 2.625 / d1) * x + 0.984375;
    }
};

const _seededRandom = seed => {
    return () => {
        seed = (seed * 9301 + 49297) % 233280;
        return seed / 233280;
    };
};

function _getBalloonRandomKeyframes(keyframesLength, options = {}) {
    const {
        seed = keyframesLength, // 允许自定义种子
        amplitude = 100, // 减小振幅使运动更温和
        smoothness = 0.3, // 平滑度参数
    } = options;

    const random = _seededRandom(seed);

    return new Array(keyframesLength).fill(0).map((_, index) => {
        if (index === keyframesLength - 1) {
            return { translateY: 0, translateX: 0 };
        }

        // 使用正弦波函数创建更平滑的随机运动
        const progress = index / (keyframesLength - 1);
        const wave1 = Math.sin(progress * Math.PI * 2 + random() * Math.PI) * amplitude;
        const wave2 = Math.cos(progress * Math.PI * 2 + random() * Math.PI) * amplitude;

        // 添加一些随机性但保持平滑
        const randomFactor = (random() * 2 - 1) * smoothness;

        return {
            translateY: wave1 + randomFactor * amplitude * 0.2 + '%',
            translateX: wave2 + randomFactor * amplitude * 0.2 + '%',
        };
    });
}

// 静态值动画时长等于元素时长的列表
export const STATIC_FULL_DURATION_KEYFRAMES = ['SUBTITLE_SCROLL_DOWN_LOOP_ONCE', 'BALLOON_RANDOM_LOOP'];

export default {
    FADE_IN: { ease: 'inOutQuint', opacity: [0, 1] },
    FADE_IN_UP: {
        ease: 'inOutQuint',
        opacity: [0, 1],
        translateY: ['20%', '0%'],
    },
    FADE_IN_DOWN: {
        ease: 'inOutQuint',
        opacity: [0, 1],
        translateY: ['-20%', '0%'],
    },
    FADE_IN_LEFT: {
        ease: 'inOutQuint',
        opacity: [0, 1],
        translateX: ['-20%', '0%'],
    },
    FADE_IN_RIGHT: {
        ease: 'inOutQuint',
        opacity: [0, 1],
        translateX: ['20%', '0%'],
    },

    FADE_OUT: { ease: 'inOutQuint', opacity: [1, 0] },
    FADE_OUT_UP: {
        ease: 'inOutQuint',
        opacity: [1, 0],
        translateY: ['0%', '-20%'],
    },
    FADE_OUT_DOWN: {
        ease: 'inOutQuint',
        opacity: [1, 0],
        translateY: ['0%', '20%'],
    },
    FADE_OUT_LEFT: {
        ease: 'inOutQuint',
        opacity: [1, 0],
        translateX: ['0%', '-20%'],
    },
    FADE_OUT_RIGHT: {
        ease: 'inOutQuint',
        opacity: [1, 0],
        translateX: ['0%', '20%'],
    },

    MOVE_IN_LEFT: { ease: 'inOutQuint', translateX: ['-2000px', '0'] },
    MOVE_IN_RIGHT: { ease: 'inOutQuint', translateX: ['2000px', '0'] },
    MOVE_IN_UP: { ease: 'inOutQuint', translateY: ['-2000px', '0'] },
    MOVE_IN_BOTTOM: { ease: 'inOutQuint', translateY: ['2000px', '0'] },
    MOVE_IN_LEFT_UP: {
        ease: 'inOutQuint',
        translateX: ['-2000px', '0'],
        translateY: ['-2000px', '0'],
    },
    MOVE_IN_LEFT_BOTTOM: {
        ease: 'inOutQuint',
        translateX: ['-2000px', '0'],
        translateY: ['2000px', '0'],
    },
    MOVE_IN_RIGHT_UP: {
        ease: 'inOutQuint',
        translateX: ['2000px', '0'],
        translateY: ['-2000px', '0'],
    },
    MOVE_IN_RIGHT_BOTTOM: {
        ease: 'inOutQuint',
        translateX: ['2000px', '0'],
        translateY: ['2000px', '0'],
    },

    MOVE_OUT_LEFT: { ease: 'inOutQuint', translateX: ['0', '-2000px'] },
    MOVE_OUT_RIGHT: { ease: 'inOutQuint', translateX: ['0', '2000px'] },
    MOVE_OUT_UP: { ease: 'inOutQuint', translateY: ['0', '-2000px'] },
    MOVE_OUT_BOTTOM: { ease: 'inOutQuint', translateY: ['0', '2000px'] },
    MOVE_OUT_LEFT_UP: {
        ease: 'inOutQuint',
        translateX: ['0', '-2000px'],
        translateY: ['0', '-2000px'],
    },
    MOVE_OUT_LEFT_BOTTOM: {
        ease: 'inOutQuint',
        translateX: ['0', '-2000px'],
        translateY: ['0', '2000px'],
    },
    MOVE_OUT_RIGHT_UP: {
        ease: 'inOutQuint',
        translateX: ['0', '2000px'],
        translateY: ['0', '-100%'],
    },
    MOVE_OUT_RIGHT_BOTTOM: {
        ease: 'inOutQuint',
        translateX: ['0', '2000px'],
        translateY: ['0', '2000px'],
    },

    WIPE_IN_LEFT: { ease: 'inOutQuint', translateX: ['-101%', '0%'] },
    WIPE_IN_RIGHT: { ease: 'inOutQuint', translateX: ['101%', '0%'] },
    WIPE_IN_UP: { ease: 'inOutQuint', translateY: ['-101%', '0%'] },
    WIPE_IN_BOTTOM: { ease: 'inOutQuint', translateY: ['101%', '0%'] },

    WIPE_OUT_LEFT: { ease: 'inOutQuint', translateX: ['0%', '-101%'] },
    WIPE_OUT_RIGHT: { ease: 'inOutQuint', translateX: ['0%', '101%'] },
    WIPE_OUT_UP: { ease: 'inOutQuint', translateY: ['0%', '-101%'] },
    WIPE_OUT_BOTTOM: { ease: 'inOutQuint', translateY: ['0%', '101%'] },

    WIPE_EDGE_IN_LEFT: { ease: 'inOutQuint', clipPath: ['inset(0 100% 0 0)', 'inset(0 0% 0 0)'] },
    WIPE_EDGE_IN_RIGHT: { ease: 'inOutQuint', clipPath: ['inset(0 0 0 100%)', 'inset(0 0 0 0%)'] },
    WIPE_EDGE_IN_UP: { ease: 'inOutQuint', clipPath: ['inset(0 0 100% 0)', 'inset(0 0 0% 0)'] },
    WIPE_EDGE_IN_BOTTOM: { ease: 'inOutQuint', clipPath: ['inset(100% 0 0 0)', 'inset(0% 0 0 0)'] },
    WIPE_EDGE_IN_HORIZONTAL: { ease: 'inOutQuint', clipPath: ['inset(0 50% 0 50%)', 'inset(0 0% 0 0%)'] },
    WIPE_EDGE_IN_VERTICAL: { ease: 'inOutQuint', clipPath: ['inset(50% 0 50% 0)', 'inset(0% 0 0% 0)'] },

    WIPE_EDGE_OUT_LEFT: { ease: 'inOutQuint', clipPath: ['inset(0 0% 0 0)', 'inset(0 100% 0 0)'] },
    WIPE_EDGE_OUT_RIGHT: { ease: 'inOutQuint', clipPath: ['inset(0 0 0 0%)', 'inset(0 0 0 100%)'] },
    WIPE_EDGE_OUT_UP: { ease: 'inOutQuint', clipPath: ['inset(0 0 0% 0)', 'inset(0 0 100% 0)'] },
    WIPE_EDGE_OUT_BOTTOM: { ease: 'inOutQuint', clipPath: ['inset(0% 0 0 0)', 'inset(100% 0 0 0)'] },
    WIPE_EDGE_OUT_HORIZONTAL: { ease: 'inOutQuint', clipPath: ['inset(0 0% 0 0)', 'inset(0 50% 0 50%)'] },
    WIPE_EDGE_OUT_VERTICAL: { ease: 'inOutQuint', clipPath: ['inset(0% 0 0% 0)', 'inset(50% 0 50% 0)'] },

    // TODO: 单独使用scale时，播放异常卡顿，猜测可能是浏览器更新导致的问题
    ZOOM_IN: { ease: 'inOutQuint', scale: [0, 1], opacity: ['0.9', '1'] },
    ZOOM_IN_UP: {
        ease: 'inOutQuint',
        scale: [0, 1],
        translateY: ['200%', '0%'],
    },
    ZOOM_IN_DOWN: {
        ease: 'inOutQuint',
        scale: [0, 1],
        translateY: ['-200%', '0%'],
    },
    ZOOM_IN_LEFT: {
        ease: 'inOutQuint',
        scale: [0, 1],
        translateX: ['-200%', '0%'],
    },
    ZOOM_IN_RIGHT: {
        ease: 'inOutQuint',
        scale: [0, 1],
        translateX: ['200%', '0%'],
    },

    ZOOM_OUT: { ease: 'inOutQuint', scale: [1, 0] },
    ZOOM_OUT_UP: {
        ease: 'inOutQuint',
        scale: [1, 0],
        translateY: ['0%', '-200%'],
    },
    ZOOM_OUT_DOWN: {
        ease: 'inOutQuint',
        scale: [1, 0],
        translateY: ['0%', '200%'],
    },
    ZOOM_OUT_LEFT: {
        ease: 'inOutQuint',
        scale: [1, 0],
        translateX: ['0%', '-200%'],
    },
    ZOOM_OUT_RIGHT: {
        ease: 'inOutQuint',
        scale: [1, 0],
        translateX: ['0%', '200%'],
    },

    FLIP_IN_X: {
        ease: 'inOutQuart',
        opacity: [0, 1],
        rotateX: ['90deg', '0deg'],
    },
    FLIP_IN_Y: {
        ease: 'inOutQuart',
        opacity: [0, 1],
        rotateY: ['90deg', '0deg'],
    },
    FLIP_OUT_X: {
        ease: 'inOutQuart',
        opacity: [1, 0],
        rotateX: ['0deg', '90deg'],
    },
    FLIP_OUT_Y: {
        ease: 'inOutQuart',
        opacity: [1, 0],
        rotateY: ['0deg', '90deg'],
    },

    POPUP_IN: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_LEFT: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_RIGHT: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_UP: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_DOWN: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_LEFT_UP: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_LEFT_DOWN: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_RIGHT_UP: { ease: 'outBack', scale: [0, 1] },
    POPUP_IN_RIGHT_DOWN: { ease: 'outBack', scale: [0, 1] },

    POPUP_OUT: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_LEFT: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_RIGHT: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_UP: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_DOWN: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_LEFT_UP: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_LEFT_DOWN: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_RIGHT_UP: { ease: 'inBack', scale: [1, 0] },
    POPUP_OUT_RIGHT_DOWN: { ease: 'inBack', scale: [1, 0] },

    ROTATE_IN_CLOCKWISE: {
        ease: 'inOutQuint',
        scale: [0, 1],
        rotate: ['-270deg', '0deg'],
    },
    ROTATE_IN_ANTIC_CLOCKWISE: {
        ease: 'inOutQuint',
        scale: [0, 1],
        rotate: ['270deg', '0deg'],
    },
    ROTATE_POPUP_IN_CLOCKWISE: {
        ease: 'outBack',
        scale: [0, 1],
        rotate: ['-270deg', '0deg'],
    },
    ROTATE_POPUP_IN_ANTIC_CLOCKWISE: {
        ease: 'outBack',
        scale: [0, 1],
        rotate: ['270deg', '0deg'],
    },

    ROTATE_OUT_CLOCKWISE: {
        ease: 'inOutQuint',
        scale: [1, 0],
        rotate: ['0deg', '270deg'],
    },
    ROTATE_OUT_ANTIC_CLOCKWISE: {
        ease: 'inOutQuint',
        scale: [1, 0],
        rotate: ['0deg', '-270deg'],
    },
    ROTATE_POPUP_OUT_CLOCKWISE: {
        ease: 'inBack',
        scale: [1, 0],
        rotate: ['0deg', '270deg'],
    },
    ROTATE_POPUP_OUT_ANTIC_CLOCKWISE: {
        ease: 'inBack',
        scale: [1, 0],
        rotate: ['0deg', '-270deg'],
    },

    BOUNCE_IN: { modifier: BOUNCE_EASING_FUN, scale: [0, 1] },
    FLASH: { modifier: BOUNCE_EASING_FUN, opacity: [0, 1] },

    BOUNCE_OUT: { modifier: BOUNCE_EASING_FUN, scale: [1, 0] },

    NEON: { modifier: BOUNCE_EASING_FUN, opacity: [0, 1], isLoop: true, coverFrameRate: 0.999 },
    SHAKE_LOOP: {
        ease: 'linear',
        rotate: ['0deg', '15deg', '0deg', '-15deg', '0deg'],
        isLoop: true,
        coverFrameRate: 0,
    },
    SHAKE_RIGHT_LOOP: {
        ease: 'linear',
        transformOrigin: ['100% 0%', '100% 0%'],
        rotate: ['0deg', '-15deg', '0deg', '15deg', '0'],
        isLoop: true,
        coverFrameRate: 0,
    },
    SHAKE_LEFT_LOOP: {
        ease: 'linear',
        transformOrigin: ['0% 0%', '0% 0%'],
        rotate: ['0deg', '-15deg', '0deg', '15deg', '0'],
        isLoop: true,
        coverFrameRate: 0,
    },
    SHAKE_RIGHT_DOWN_LOOP: {
        ease: 'linear',
        transformOrigin: ['100% 100%', '100% 100%'],
        rotate: ['0deg', '-15deg', '0deg', '15deg', '0'],
        isLoop: true,
        coverFrameRate: 0,
    },
    SHAKE_LEFT_DOWN_LOOP: {
        ease: 'linear',
        transformOrigin: ['0% 100%', '0% 100%'],
        rotate: ['0deg', '-15deg', '0deg', '15deg', '0'],
        isLoop: true,
        coverFrameRate: 0,
    },

    DRIFT_IN_LEFT: { ease: 'linear', translateX: ['-100%', '0%'] },
    DRIFT_IN_RIGHT: { ease: 'linear', translateX: ['100%', '0%'] },
    DRIFT_IN_UP: { ease: 'linear', translateY: ['-100%', '0%'] },
    DRIFT_IN_DOWN: { ease: 'linear', translateY: ['100%', '0%'] },

    DRIFT_OUT_LEFT: { ease: 'linear', translateX: ['0%', '100%'] },
    DRIFT_OUT_RIGHT: { ease: 'linear', translateX: ['0%', '-100%'] },
    DRIFT_OUT_UP: { ease: 'linear', translateY: ['0%', '100%'] },
    DRIFT_OUT_DOWN: { ease: 'linear', translateY: ['0%', '-100%'] },

    BREATH_IN: { ease: 'linear', scale: [0.8, 1], opacity: [0, 1] },
    BREATH_OUT: { ease: 'linear', scale: [1, 0.8], opacity: [1, 0] },

    // STOMP: { ease: 'linear', scale: [10, 1]},

    SCRAPBOOK_IN_LEFT: {
        ease: 'steps(3)',
        translateX: ['-100%', '0%'],
        translateY: ['100%', '0%'],
        rotate: [0, '-8deg', 0, '8deg', 0],
    },
    SCRAPBOOK_IN_RIGHT: {
        ease: 'steps(3)',
        translateX: ['100%', '0%'],
        translateY: ['100%', '0%'],
        rotate: [0, '8deg', 0, '-8deg', 0],
    },
    SCRAPBOOK_OUT_LEFT: {
        ease: 'steps(3)',
        translateX: ['0%', '-100%'],
        translateY: ['0%', '100%'],
        rotate: [
            { from: 0, to: '-8deg', duration: 0.25 },
            { from: '-8deg', to: 0, duration: 0.25 },
            { from: 0, to: '8deg', duration: 0.25 },
            { from: '8deg', to: 0, duration: 0.25 },
            { from: 0, to: 0, duration: 0.01 },
        ],
    },
    SCRAPBOOK_OUT_RIGHT: {
        ease: 'steps(3)',
        translateX: ['0%', '100%'],
        translateY: ['0%', '100%'],
        rotate: [
            { from: 0, to: '8deg', duration: 0.25 },
            { from: '8deg', to: 0, duration: 0.25 },
            { from: 0, to: '-8deg', duration: 0.25 },
            { from: '-8deg', to: 0, duration: 0.25 },
            { from: 0, to: 0, duration: 0.01 },
        ],
    },

    DASH_IN: { ease: 'steps(3)', scale: [0.1, 1] },
    DASH_OUT: {
        ease: 'steps(3)',
        scale: [1, 0.1],
    },

    THREE_D_FLIP_X_IN: { ease: 'linear', rotateX: ['-90deg', '0deg'] },
    THREE_D_FLIP_Y_IN: { ease: 'linear', rotateY: ['-90deg', '0deg'] },
    THREE_D_FLIP_X_OUT: { ease: 'linear', rotateX: ['0deg', '-90deg'] },
    THREE_D_FLIP_Y_OUT: { ease: 'linear', rotateY: ['0deg', '-90deg'] },

    TUMBLE_LEFT_IN: { ease: 'inOutBack', translateX: ['-100%', '0%'], rotate: ['-220deg', '0deg'] },
    TUMBLE_RIGHT_IN: { ease: 'inOutBack', translateX: ['100%', '0%'], rotate: ['220deg', '0deg'] },
    // todo： 当前面有旋转动画的话，该动画会异常
    TUMBLE_LEFT_OUT: {
        ease: 'inOutBack',
        translateX: ['0%', '-100%'],
        rotate: ['0deg', '-220deg'],
    },
    TUMBLE_RIGHT_OUT: {
        ease: 'inOutBack',
        translateX: ['0%', '100%'],
        rotate: ['0deg', '220deg'],
    },
    STOMP_IN: { ease: 'inOutQuint', scale: [2, 1], opacity: [0, 1] },
    STOMP_OUT: { ease: 'inOutQuint', scale: [1, 2], opacity: [1, 0] },

    ALL_HEARTBEAT_LOOP: {
        isLoop: true,
        scale: [
            { from: 1, to: 0.6, duration: 0.3, ease: 'cubicBezier(0.250, 0.250, 0.025, 0.715)' },
            { from: 0.6, to: 1, duration: 0.5, ease: 'linear' },
            { from: 1, to: 1.2, duration: 0.1, ease: 'linear' },
            { from: 1.2, to: 1, duration: 0.1, ease: 'linear' },
        ],
    },

    ALL_HEARTBEAT_LOOP_2: {
        isLoop: true,
        scale: [
            { from: 1, to: 1.4, duration: 0.3, ease: 'cubicBezier(0.250, 0.250, 0.025, 0.715)' },
            { from: 1.4, to: 1, duration: 0.3, ease: 'linear' },
            { from: 1, to: 1.1, duration: 0.2, ease: 'linear' },
        ],
    },

    ALL_FLIP_Y_LOOP: {
        isLoop: true,
        backfaceVisibility: 'visible',
        rotateY: [0, 360],
        ease: 'linear',
        duration: 2,
    },

    ALL_FLIP_X_LOOP: {
        isLoop: true,
        rotateX: [0, 360],
        duration: 1,
        backfaceVisibility: 'visible',
        ease: 'linear',
        duration: 2,
    },

    ALL_JUMP_LOOP: {
        isLoop: true,
        translateY: [
            { from: 0, to: '-80%', duration: 0.4, ease: 'cubicBezier(0.045, 0.405, 0.535, 0.990)' },
            { from: '-80%', to: 0, duration: 0.4, ease: 'cubicBezier(0.275, 0.015, 0.490, 0.765)' },
            { from: 0, to: '-10%', duration: 0.16, ease: 'cubicBezier(0.295, 0.185, 0.585, 0.795)' },
            { from: '-10%', to: 0, duration: 0.1, ease: 'linear' },
        ],
    },

    ALL_JUMP_DOWN_LOOP: {
        isLoop: true,
        translateY: [
            { from: 0, to: '80%', duration: 0.4, ease: 'cubicBezier(0.045, 0.405, 0.535, 0.990)' },
            { from: '80%', to: 0, duration: 0.4, ease: 'cubicBezier(0.275, 0.015, 0.490, 0.765)' },
            { from: 0, to: '10%', duration: 0.16, ease: 'cubicBezier(0.295, 0.185, 0.585, 0.795)' },
            { from: '10%', to: 0, duration: 0.1, ease: 'linear' },
        ],
    },

    ALL_JUMP_RIGHT_LOOP: {
        isLoop: true,
        translateX: [
            { from: 0, to: '80%', duration: 0.4, ease: 'cubicBezier(0.045, 0.405, 0.535, 0.990)' },
            { from: '80%', to: 0, duration: 0.4, ease: 'cubicBezier(0.275, 0.015, 0.490, 0.765)' },
            { from: 0, to: '10%', duration: 0.16, ease: 'cubicBezier(0.295, 0.185, 0.585, 0.795)' },
            { from: '10%', to: 0, duration: 0.1, ease: 'linear' },
        ],
    },

    ALL_JUMP_LEFT_LOOP: {
        isLoop: true,
        translateX: [
            { from: 0, to: '-80%', duration: 0.4, ease: 'cubicBezier(0.045, 0.405, 0.535, 0.990)' },
            { from: '-80%', to: 0, duration: 0.4, ease: 'cubicBezier(0.275, 0.015, 0.490, 0.765)' },
            { from: 0, to: '-10%', duration: 0.16, ease: 'cubicBezier(0.295, 0.185, 0.585, 0.795)' },
            { from: '-10%', to: 0, duration: 0.1, ease: 'linear' },
        ],
    },

    ALL_PULSE_LOOP: {
        isLoop: true,
        scale: [1, 1.2, 1],
    },

    ALL_ROTATE_LOOP: {
        isLoop: true,
        rotate: [0, 360],
        duration: 3,
        ease: 'linear',
    },

    ALL_SPIN_3D_LOOP: {
        isLoop: true,
        perspective: [1.054, 1.054],
        rotateY: [0, 360],
        duration: 3,
        backfaceVisibility: 'visible',
        ease: 'cubicBezier(0.835, -0.005, 0.185, 1.030)',
    },

    ALL_SPIN_3D_VERTICAL_LOOP: {
        isLoop: true,
        perspective: [1.054, 1.054],
        rotateX: [0, 360],
        duration: 3,
        backfaceVisibility: 'visible',
        ease: 'cubicBezier(0.835, -0.005, 0.185, 1.030)',
    },

    ALL_SPIN_SMOOTH_LOOP: {
        isLoop: true,
        rotate: [0, 360],
        duration: 3,
        ease: 'cubicBezier(0.835, -0.005, 0.185, 1.030)',
    },

    ALL_SWAY_3D_LOOP: {
        isLoop: true,
        backfaceVisibility: 'visible',
        perspective: [0.6, 0.6],
        rotateY: [
            { from: 0, to: -25, duration: 0.8, ease: 'linear' },
            { from: -25, to: 25, duration: 0.8, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 25, to: 0, duration: 0.4, ease: 'linear' },
        ],
    },

    ALL_SWAY_3D_VERTICAL_LOOP: {
        isLoop: true,
        backfaceVisibility: 'visible',
        perspective: [0.6, 0.6],
        rotateX: [
            { from: 0, to: -25, duration: 0.8, ease: 'linear' },
            { from: -25, to: 25, duration: 0.8, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 25, to: 0, duration: 0.4, ease: 'linear' },
        ],
    },

    ALL_SWAY_LOOP: {
        isLoop: true,
        rotate: [
            { from: 0, to: 15, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 15, to: -15, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: -15, to: 0, duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
        ],
    },

    ALL_SIMPLE_SWAY_LOOP: {
        isLoop: true,
        coverFrameRate: 0.25,
        rotate: [15, -15, 15],
        ease: 'linear',
    },

    ALL_WIGGLE_LOOP: {
        isLoop: true,

        translateY: [
            { from: 0, to: '15%', duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: '15%', to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '-15%', duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: '-15%', to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
        ],
        translateX: [
            { from: 0, to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '15%', duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: '15%', to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '-15%', duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: '-15%', to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
        ],
        rotate: [
            { from: 0, to: 18, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 18, to: -12, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: -12, to: 15, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 15, to: -18, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: -18, to: 0, duration: 0.4, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
        ],
    },

    ALL_JIGGLE_SHAPE_VEE_LOOP: {
        isLoop: true,
        translateY: [
            { from: 0, to: '1.2%', duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '1.2%', duration: 0.2, ease: 'inOutSine' },
            { from: 0, to: '-1.2%', duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '1.2%', duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '1.2%', duration: 0.2, ease: 'inOutSine' },
            { from: 0, to: '-1.2%', duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
        ],
        translateX: [
            { from: 0, to: '1.2%', duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: '1.2%', to: 0, duration: 0.2, ease: 'inOutSine' },
            { from: '1.2%', to: 0, duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: 0, to: '1.2%', duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
            { from: '1.2%', to: 0, duration: 0.2, ease: 'inOutSine' },
            { from: '1.2%', to: 0, duration: 0.2, ease: 'cubicBezier(0.555, 0.035, 0.460, 0.915)' },
        ],
    },

    ALL_WINDSHIELD_WIPER_LOOP: {
        isLoop: true,
        coverFrameRate: 0.5,
        rotate: [
            { from: -23, to: 23, duration: 1, ease: 'cubicBezier(0.5, 0.00, 0.5, 1.00)' },
            { to: -23, duration: 1, ease: 'cubicBezier(0.5, 0.00, 0.5, 1.00)' },
        ],
        translateX: [
            { from: '-20%', to: '20%', duration: 1, ease: 'cubicBezier(0.5, 0.00, 0.5, 1.00)' },
            { from: '20%', to: '-20%', duration: 1, ease: 'cubicBezier(0.5, 0.00, 0.5, 1.00)' },
        ],
    },

    ALL_PENDULUM_SWING_LOOP: {
        transformOrigin: ['50% 100%', '50% 100%'],
        duration: 2,
        rotate: [
            { from: -10, to: 10, ease: 'cubicBezier(0.5, 0.00, 0.5, 1.00)' },
            { to: -10, ease: 'cubicBezier(0.5, 0.00, 0.5, 1.00)' },
        ],
        isLoop: true,
        coverFrameRate: 0.5,
    },

    ALL_ROATATE_PULSE_FLICKER_LOOP: {
        isLoop: true,
        rotate: [
            ...Array.from({ length: 12 }, (_, i) => ({
                from: i * 30,
                to: (i + 1) * 30,
                duration: 0.8,
                ease: 'linear',
            })),
        ],
        scale: Array.from({ length: 12 }, (_, i) => [
            { from: 1, to: 0.7, duration: 0.8 / 3, ease: 'linear' },
            { from: 0.7, to: 1, duration: 0.8 / 3, ease: 'linear' },
            { from: 1, to: 1, duration: 0.8 / 3, ease: 'linear' },
        ]).reduce((calc, cur) => [...calc, ...cur], []),
        opacity: Array.from({ length: 12 }, (_, i) => [
            { from: 1, to: 0.5, duration: 0.8 / 3, ease: 'linear' },
            { from: 0.5, to: 1, duration: 0.8 / 3, ease: 'linear' },
            { from: 1, to: 1, duration: 0.8 / 3, ease: 'linear' },
        ]).reduce((calc, cur) => [...calc, ...cur], []),
    },

    SUBTITLE_SCROLL_DOWN_LOOP: {
        ease: 'linear',
        isLoop: true,
        methods: {
            goToCoverFrame: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    target.style.transform = 'translateY(0px)';
                });
            },
        },
    },

    SUBTITLE_SCROLL_DOWN_LOOP_ONCE: {
        ease: 'linear',
        isLoop: true,
        methods: {
            goToCoverFrame: targets => {
                if (!targets) return;
                targets.forEach(target => {
                    target.style.transform = 'translateY(0px)';
                });
            },
        },
    },

    BALLOON_RANDOM_LOOP: {
        ease: 'inOutSine',
        isLoop: true,
        methods: {
            customKeyframes: (options = {}) => {
                const lensLength = options.length;
                return _getBalloonRandomKeyframes(lensLength, {
                    amplitude: 14,
                    smoothness: 0.8,
                });
            },
        },
    },

    ALL_SPIN_3D_IN: {
        perspective: [1.054, 1.054],
        rotateY: [-90, 360],
        backfaceVisibility: 'visible',
        ease: 'cubicBezier(0.835, -0.005, 0.185, 1.030)',
    },

    ALL_SPIN_3D_OUT: {
        perspective: [1.054, 1.054],
        rotateY: [360, -90],
        backfaceVisibility: 'visible',
        ease: 'cubicBezier(0.835, -0.005, 0.185, 1.030)',
    },

    ALL_HEARTBEAT_IN: {
        scale: [
            { from: 1, to: 0.6, duration: 0.3, ease: 'cubicBezier(0.250, 0.250, 0.025, 0.715)' },
            { from: 0.6, to: 1, duration: 0.5, ease: 'linear' },
            { from: 1, to: 1.2, duration: 0.1, ease: 'linear' },
            { from: 1.2, to: 1, duration: 0.1, ease: 'linear' },
        ],
    },
    ALL_HEARTBEAT_OUT: {
        scale: [
            { from: 1, to: 0.6, duration: 0.3, ease: 'cubicBezier(0.250, 0.250, 0.025, 0.715)' },
            { from: 0.6, to: 1, duration: 0.4, ease: 'linear' },
            { from: 1, to: 1.2, duration: 0.1, ease: 'linear' },
            { from: 1.2, to: 1, duration: 0.08, ease: 'linear' },
            { from: 1, to: 0.6, duration: 0.12, ease: 'linear' },
        ],
    },

    ALL_JUMP_UP_IN: {
        translateY: [
            { from: 0, to: '-80%', duration: 0.4, ease: 'cubicBezier(0.045, 0.405, 0.535, 0.990)' },
            { from: '-80%', to: 0, duration: 0.38, ease: 'cubicBezier(0.275, 0.015, 0.490, 0.765)' },
            { from: 0, to: '-10%', duration: 0.14, ease: 'cubicBezier(0.295, 0.185, 0.585, 0.795)' },
            { from: '-10%', to: 0, duration: 0.08, ease: 'linear' },
        ],
    },
    ALL_JUMP_UP_OUT: {
        translateY: [
            { from: 0, to: '-80%', duration: 0.4, ease: 'cubicBezier(0.045, 0.405, 0.535, 0.990)' },
            { from: '-80%', to: 0, duration: 0.38, ease: 'cubicBezier(0.275, 0.015, 0.490, 0.765)' },
            { from: 0, to: '-10%', duration: 0.14, ease: 'cubicBezier(0.295, 0.185, 0.585, 0.795)' },
            { from: '-10%', to: 0, duration: 0.08, ease: 'linear' },
            { from: '0%', to: '0%', duration: 0.01, ease: 'outBack' },
        ],
        ease: 'linear',
    },
};
